import Chroma from 'chroma-js';

export const partyColumns = [
  'cdu',
  'spd',
  'gruene',
  'fdp',
  'die.linke',
  'abi',
  'aktiv',
  'allianz',
  'arminius.bund',
  'afd',
  'auf',
  'aufbruch.c',
  'aufbruch.du',
  'aufbruch.leverkusen',
  'bamh',
  'basisdemokratie.jetzt',
  'basisdemokratie',
  'bbb',
  'bbz',
  'bfb',
  'bfd',
  'bfh',
  'bfho',
  'bfs',
  'bg',
  'big:',
  'big.dergah',
  'bl',
  'bob',
  'bsd',
  'bvt',
  'bwl',
  'buergerliste',
  'buergernaehe',
  'buefo.klimaliste',
  'buendnis.c',
  'buergerforum',
  'cdu.fdp',
  'cdu.gruene',
  'cdu.gruene.fdp',
  'dal',
  'die.aktive',
  'die.einheit',
  'die.partei',
  'die.rechte',
  'die.stadtgestalter',
  'die.violetten',
  'dkp',
  'dos',
  'dsp',
  'duw',
  'ebb.fw',
  'echt.remscheid',
  'einzelbewerber',
  'familie',
  'fbi.freie.waehler',
  'fbi',
  'fbu',
  'fox',
  'freie.waehler',
  'fuw.freie.waehler',
  'fw.hsk',
  'fw.kreis.heinsberg',
  'fw.kreisverband.unna',
  'fw',
  'fw.en',
  'fw.kv',
  'fwg.kierspe',
  'fwg.kreis.wesel',
  'fwg.muehlenkreis',
  'fwg',
  'fwg.uwg',
  'fwk',
  'fwo.du',
  'fuer.paderborn',
  'gfl',
  'gut',
  'hagen.aktiv',
  'hak',
  'judu',
  'klima.freunde',
  'klimaliste.duesseldorf',
  'ld',
  'lib',
  'mbi',
  'msp',
  'npd',
  'ofb',
  'op',
  'pdf',
  'piraten',
  'piraten.waehlergruppen',
  'pro.hamm',
  'pro.nrw',
  'pro.remscheid',
  'pro.wuppertal',
  'rep',
  'sbl',
  'sfd',
  'sgd',
  'sgu',
  'slb',
  'so',
  'solingen.aktiv',
  'sozial',
  'spd.gruene',
  'spd.gruene.die.linke',
  'stadtpartei',
  'tierschutz.hier',
  'tierschutz',
  'tierschutzpartei',
  'ub.uwg',
  'ubf',
  'ubp',
  'ufw',
  'unabhaengige.buerger',
  'uwg.aachen',
  'uwg.im.kreis.coesfeld',
  'uwg.mk',
  'uwg.oberberg',
  'uwg',
  'uwg.kreis',
  'uwg.me',
  'uwg.cwg',
  'uwg.freie.waehler',
  'uwg.fw',
  'uwg.freie.buerger',
  'uwv',
  'v.partei.3',
  'vereinigte.waehlergemeinschaften.kreis.kleve.ev',
  'volksabstimmung',
  'volt',
  'w.i.r',
  'wfu',
  'wfw.fw',
  'wgd',
  'wgr.1',
  'wgr.2',
  'wgr.3',
  'wgr.4',
  'wgr.5',
  'wgr.6',
  'wgr.7',
  'wgr.8',
  'wgr.9',
  'wgr.10',
  'wgr.11',
  'widerstand.2020.wir.fuer.duesseldorf',
  'win',
  'wir.aus.muelheim',
  'wir.fuer.freiheit.und.grundgesetz',
  'wir.in.dortmund',
  'wir.sind.koeln',
  'wir',
  'wir2020',
  'wuz',
  'wwh',
  'zentrum',
  'oedp',
  'waehlergruppen'
];

export const partyColumnsComp = partyColumns.map(c => `${c}_Vergleich`);
export const invalidVotesColumn = 'Ungültige.Stimmzettel';
export const Voters = 'Wähler';
export const countStatus = 'Stand';
export const invalidVotesColumnComp = `Ungültige.Stimmen_Vergleich`;
export const validVotesColumn = 'Gültige.Stimmen';
export const validVotesColumnComp = `${validVotesColumn}_Vergleich`;
export const allVotesColumn = 'Wahlberechtigte';
export const allVotesColumnComp = `${allVotesColumn}_Vergleich`;
export const topParties = partyColumns.slice(0, 6);
//export const cduShortName = 'CDU';

export const numColumns = [
  ...partyColumns,
  ...partyColumnsComp,
  invalidVotesColumn,
  invalidVotesColumnComp,
  validVotesColumn,
  Voters,
  validVotesColumnComp,
  allVotesColumn,
  allVotesColumnComp,
  countStatus,
  ...ARTICLE_CONFIG.candidates
];

const colorSonstigeMin = '#f3f3f3';
const colorSonstigeMax = '#888';

// const colorSonstigeMinA = '#f3f3f3';
// const colorSonstigeMaxA = '#888';

export const partyConfig = {


// Parteien (30)
  cdu: {
    min: '#d8d8d8',
    max: '#373737',
    name: 'CDU'
  },
  spd: {
    min: '#ffe3e1',
    max: '#DB4240',
    name: 'SPD'
  },
  gruene: {
    min: '#d6f3d4',
    max: '#4BA345',
    name: 'Grüne'
  },
  fdp: {
    min: '#fff7ce',
    max: '#F6BB00',
    name: 'FDP'
  },
  'die.linke': {
    min: '#fad5ed',
    max: '#96276E',
    name: 'Die Linke',
    shortname: 'Linke'
  },
  afd: {
    min: '#cff6ff',
    max: '#34A3D2',
    name: 'AfD'
  },
  piraten: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Piraten",
    shortname: "Pirat."
  },
  npd: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "NPD",
    shortname: "NPD"
  },
  rep: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Republikaner",
    shortname: "REP"
  },
  "die.partei": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Die Partei",
    shortname: "Partei"
  },
  big: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BIG",
    shortname: "BIG"
  },
  oedp: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "ÖDP",
    shortname: "ÖDP"
  },
  zentrum: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Zentrum",
    shortname: "Zentr."
  },
  tierschutzpartei: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Tierschutzpartei",
    shortname: "Tier.p"
  },
  dkp: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "DKP",
    shortname: "DKP"
  },
  "die.rechte": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Die Rechte",
    shortname: "Rechte"
  },
  volksabstimmung: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Volksabstimmung",
    shortname: "VA"
  },
  so: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "SO!",
    shortname: "SO!"
  },
  familie: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Familie",
    shortname: "Fam."
  },
  "die.violetten": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Die Violetten",
    shortname: "Viol."
  },
  "tierschutz.hier": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Tierschutz hier!",
    shortname: "Tier.h"
  },
  "aufbruch.c": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Aufbruch C",
    shortname: "Aufbr.C"
  },
  "buendnis.c": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bündnis C",
    shortname: "Bü.C"
  },
  dsp: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "DSP",
    shortname: "DSP"
  },
  dos: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "DOS",
    shortname: "DOS"
  },
  msp: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Moderne Soziale",
    shortname: "MSP"
  },
  pdf: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Partei d. Fortschr.",
    shortname: "PdF"
  },
  "basisdemokratie.jetzt": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Basisdemokratie jetzt",
    shortname: "Bj"
  },
  volt: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Volt",
    shortname: "Volt"
  },
  "v.partei.3": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "V-Partei³",
    shortname: "V"
  },
//EINZELBEWERBER
  einzelbewerber: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Einzelbewerber/-in",
    shortname: "Einzel"
  },
// WÄHLERGRUPPEN (max. 11 pro Kreis)
  "freie.waehler": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Freie Wähler",
    shortname: "FW"
  },
  "klimaliste.duesseldorf": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Klimaliste Düsseldorf",
    shortname: "Klima"
  },
  "widerstand.2020.wir.fuer.duesseldorf": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Widerstand 2020",
    shortname: "Wider"
    },
  judu: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Junges Duisburg",
    shortname: "JUDU"
  },
  dal: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Alternative Liste",
    shortname: "DAL"
  },
  bl: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bürgerlich Liberale",
    shortname: "BL"
  },
  sgu: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "SGU",
    shortname: "SGU"
  },
  allianz: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Allianz Duisburg",
    shortname: "All."
  },
  "aufbruch.du": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Aufbruch Duisburg",
    shortname: "Auf"
  },
  "big.dergah": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BIG-DERGAH",
    shortname: "BIG+"
  },
  bfd: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bündnis f. Duisburg",
    shortname: "BfD"
  },
  sfd: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Solidarität f. Duisburg",
    shortname: "SfD"
  },
  tierschutz: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG Tierschutz",
    shortname: "Tier"
  },
  wgd: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wir gestalten Duisburg",
    shortname: "WGD"
  },
  "ebb.fw": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "EBB Freie Wähler",
    shortname: "ebbFW"
  },
  slb: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Sozial Liberales Bndn.",
    shortname: "SLB"
    },
  "uwg.fw": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG/FW",
    shortname: "UWG/FW"
  },
  wuz: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wg. Unsere Zukunft",
    shortname: "WUZ"
  },
  wir: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "wir Krefeld",
    shortname: "wir"
  },
  mbi: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "MBI",
    shortname: "MBI"
  },
  bamh: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BAMH",
    shortname: "BAMH"
    },
  "wir.aus.muelheim": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wir aus Mülheim",
    shortname: "WAM"
  },
  bfb: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BfB",
    shortname: "BfB"
  },
  bob: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BOB",
    shortname: "BOB"
  },
  ofb: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "OfB",
    shortname: "OfB"
  },
  "w.i.r": {
      min: colorSonstigeMin,
      max: colorSonstigeMax,
      name: "W.I.R.",
      shortname: "W.I.R."
    },
  "pro.remscheid": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Pro Remscheid",
    shortname: "Pro.R"
    },
  "echt.remscheid": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "echt.Remscheid",
    shortname: "echt"
  },
  bfs: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BfS",
    shortname: "BfS"
  },
  "solingen.aktiv": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Solingen aktiv",
    shortname: "aktiv"
  },
  fbu: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FBU",
    shortname: "FBU"
  },
  abi: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "ABI",
    shortname: "ABI"
  },
  "wfw.fw": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WfW/FW",
    shortname: "WfW+"
  },
  "pro.wuppertal": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "PRO Wuppertal",
    shortname: "Pro.W"
  },
  "vereinigte.waehlergemeinschaften.kreis.kleve.ev": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "VWG Kleve",
    shortname: "VWG.K"
  },
  bsd: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BSD",
    shortname: "BSD"
  },
  "uwg.me": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG Mettmann",
    shortname: "UWG"
  },
  "die.aktive": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Die Aktive",
    shortname: "Aktive"
  },
  "uwg.freie.waehler": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG/Freie Wähler",
    shortname: "UWG+"
  },
  "fw.kv": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FW-KV",
    shortname: "FW.KV"
  },
  "fwg.kreis.wesel": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FWG Wesel",
    shortname: "FWG"
  },
  fox: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FoX",
    shortname: "FoX"
  },
  "uwg.aachen": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG Aachen",
    shortname: "UWG"
  },
  "wir.fuer.freiheit.und.grundgesetz": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WIR",
    shortname: "WIR"
  },
  bbb: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BürgerBundBonn",
    shortname: "BBB"
  },
  "klima.freunde": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Klimaliste/Freunde",
    shortname: "Klima"
  },
  fwk: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Freie Wähler Köln",
    shortname: "FWK"
  },
  gut: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "GUT Köln",
    shortname: "GUT"
  },
  "wir.sind.koeln": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wir sind Köln",
    shortname: "Wir"
  },
  buergerliste: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bürgerliste",
    shortname: "BL"
  },
  op: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Opladen Plus",
    shortname: "OP"
  },
  "aufbruch.leverkusen": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Aufbruch Leverkusen",
    shortname: "Auf"
  },
  "buefo.klimaliste": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Büfo - Klimaliste",
    shortname: "Büfo"
  },
  ufw: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UFW",
    shortname: "UFW"
  },
  uwg: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG",
    shortname: "UWG"
  },
  fw: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FW",
    shortname: "FW"
  },
  uwv: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWV",
    shortname: "UWV"
  },
  "fw.kreis.heinsberg": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FW Heinsberg",
    shortname: "FW"
  },
 "uwg.oberberg": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG Oberberg",
    shortname: "UWG"
  },
  "fwo.du": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FWO/DU",
    shortname: "FWO/DU"
  },
  bwl: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BWL",
    shortname: "BWL"
  },
  "fuw.freie.waehler": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FUW  Rhein-Sieg",
    shortname: "FUW"
  },
  win: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WIN",
    shortname: "WIN"
  },
  auf: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "AUF Gelsenkirchen",
    shortname: "AUF"
  },
  stadtpartei: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Stadtpartei",
    shortname: "Stadt"
  },
  "uwg.im.kreis.coesfeld": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG",
    shortname: "UWG"
  },
  ubp: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UBP",
    shortname: "UBP"
  },
  aktiv: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Aktiv",
    shortname: "Aktiv"
  },
  wir2020: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WIR2020",
    shortname: "WIR"
  },
  fwg: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FWG",
    shortname: "FWG"
  },
  buergernaehe: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bürgernähe",
    shortname: "Brgn."
  },
  bbz: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BBZ",
    shortname: "BBZ"
  },
  lib: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "LiB",
    shortname: "LiB"
  },
   ubf: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UBF",
    shortname: "UBF"
  },
  "fwg.uwg": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FWG-UWG",
    shortname: "FWG+"
  },
  "uwg.kreis": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Freie Wähler (UWG/LBA)",
    shortname: "UWG"
  },
  bfh: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bürger für Höxter",
    shortname: "BfH"
  },
  "uwg.cwg": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG/CW",
    shortname: "UWG+"
  },
  "fwg.muehlenkreis": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FWG Mühlenkreis",
    shortname: "FWG"
  },
  "ub.uwg": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UB-UWG",
    shortname: "UB+"
  },
  "fbi.freie.waehler": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FBI Freie Wähler",
    shortname: "FBI"
  },
  "fuer.paderborn": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Für Paderborn",
    shortname: "für.P"
  },
  sgd: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "SG Dellbrück",
    shortname: "SGD"
  },
  "uwg.freie.buerger": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG Freie Bürger",
    shortname: "UWG"
  },
  "die.stadtgestalter": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Die Stadtgestalter",
    shortname: "Stadt"
  },
  sozial: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Soziale Liste",
    shortname: "Sozial"
  },
  fbi: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FBI",
    shortname: "FBI"
  },
  bvt: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BVT",
    shortname: "BVT"
  },
  "wir.in.dortmund": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WiR in Dortmund",
    shortname: "WiR"
  },
  "hagen.aktiv": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Hagen aktiv",
    shortname: "aktiv"
  },
  bfho: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bürger f. Hohenlimburg",
    shortname: "BfHo"
  },
  hak: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Hagener Aktivisten-Kr.",
    shortname: "HAK"
  },
  "pro.hamm": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Pro Hamm",
    shortname: "Pro.H"
  },
  "unabhaengige.buerger": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Unabhängige Bürger",
    shortname: "UB"
  },
  wwh: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wg. Wanne-Herne",
    shortname: "WWH"
  },
  "fw.en": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FW Ennepe-Ruhr",
    shortname: "FW"
  },
  buergerforum: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Bürgerforum",
    shortname: "Büfo"
  },
  sbl: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Sauerl. Bürgerliste",
    shortname: "SBL"
  },
  "fw.hsk": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Freie Wähler HSK",
    shortname: "FW"
  },
  "uwg.mk": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "UWG Märkischer Kr.",
    shortname: "UWG"
  },
  "fwg.kierspe": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FWG Kierspe",
    shortname: "FWG"
  },
  bg: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "BG Soest",
    shortname: "BG"
  },
  "fw.kreisverband.unna": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "FW Unna",
    shortname: "FW"
  },
  gfl: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Gemeinsam f. Lünen",
    shortname: "GFL"
  },
  wfu: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wir für Unna",
    shortname: "WfU"
  },
// WÄHLERGRUPPEN GENERISCH
  "wgr.1": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 1",
    shortname: "WGr1"
  },
  "wgr.2": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 2",
    shortname: "WGr2"
  },
  "wgr.3": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 3",
    shortname: "WGr3"
  },
  "wgr.4": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 4",
    shortname: "WGr4"
  },
  "wgr.5": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 5",
    shortname: "WGr5"
  },
  "wgr.6": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 6",
    shortname: "WGr6"
  },
  "wgr.7": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 7",
    shortname: "WGr7"
  },
  "wgr.8": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 8",
    shortname: "WGr8"
  },
  "wgr.9": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 9",
    shortname: "WGr9"
  },
  "wgr.10": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 10",
    shortname: "WGr10"
  },
  "wgr.11": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "WGR 11",
    shortname: "WGr11"
  },
  waehlergruppen: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Wählergruppen",
    shortname: "WGr"
  }, 
// NICHT BEI KREISEN AUFGEFÜHRT (LEITDATEI)
  "arminius.bund": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Arminius-Bund",
    shortname: "Arminius"
  },
  basisdemokratie: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Basisdemokratie",
    shortname: "Basis"
  },
  "die.einheit": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Die Einheit",
    shortname: "Einheit"
  },
  duw: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "DUW",
    shortname: "DUW"
  },
  ld: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "LD",
    shortname: "LD"
  },
  "piraten.waehlergruppen": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Piraten/Wählergr.",
    shortname: "Pirat.Wgr."
  },
  "pro.nrw": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "PRO NRW",
    shortname: "Pro.NRW"
  },
// WAHLBÜNDNISSE (NICHT BEI KREISEN AUFGEFÜHRT, LEITDATEI)
  "cdu.fdp": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "CDU/FDP",
    shortname: "CDU/FDP"
  },
  "cdu.gruene": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "CDU/Grüne",
    shortname: "CDU/Grüne"
  },
  "cdu.gruene.fdp": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "CDU/Grüne/FDP",
    shortname: "Bündnis"
  },
  "spd.gruene": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "SPD/Grüne",
    shortname: "SPD/Grüne"
  },
  "spd.gruene.die.linke": {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "SPD/Grüne/Linke",
    shortname: "Bündnis"
  },
  // SONSTIGE/DEFAULT
  sonstige: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: "Sonstige",
    shortname: "Sonst."
  },
  default: {
    min: colorSonstigeMin,
    max: colorSonstigeMax
  }
};

export const cityAgs = [
  '05111', '05112', '05113', '05114', '05116', '05117', '05119', '05120', '05122', '05124', '05313', '05314', '05315', '05316', '05512', '05513', '05515', '05711', '05911', '05913', '05914', '05915', '05916'
];

export function getLimits(values) {
  return Chroma.limits(values, 'q', 20);
}

export function getPartyColor(partyName) {
  return partyConfig[partyName] ? partyConfig[partyName] : partyConfig.default;
}

export function getPartyName(partyName) {
  return partyConfig[partyName] ? partyConfig[partyName].name : partyName;
}

export function getPartyNameShort(partyName, areaId = '') {
 /* if (
    partyName === 'CDU' &&
    areaId.substr(0, 2) === '09' &&
    baseconfig.app.unionShortName
  ) {
    return 'CSU';
   }*/
  if (partyConfig[partyName]) {
    return partyConfig[partyName].shortname
      ? partyConfig[partyName].shortname
      : partyConfig[partyName].name;
  }

  return partyName;
}
